import React from "react";
import classnames from "classnames";
import { GeneralIcon, GeneralIcons } from "modules/common/components/planr/icon/Generalcon";
import { AccessState } from "../../models/access-tree";
import styles from "./AccessEditor.module.scss";

const ICONS: Record<AccessState, GeneralIcons> = {
    on: "general-checkbox-orange",
    mgr: "general-checkbox-dark",
    plus: "general-checkbox",
    minus: "general-checkbox-denied",
    off: "general-zero-checkbox",
};

/** Галочка права: вид — откуда право (должность, руководство, личное исключение) */
export const AccessCheck = ({ state, label, disabled, onClick, children, size = 18 }: AccessCheckProps) => {
    const enabled = state !== "off" && state !== "minus";

    return (
        <button
            type="button"
            role="checkbox"
            aria-checked={enabled}
            aria-label={children ? undefined : label}
            title={label}
            disabled={disabled}
            onClick={onClick}
            className={classnames(styles.check, children ? [styles.chip, styles[state]] : undefined)}
        >
            <GeneralIcon type={ICONS[state]} size={size} className={styles.checkIcon} />
            {children && <span className={styles.chipLabel}>{children}</span>}
        </button>
    );
};

interface AccessCheckProps {
    state: AccessState;
    /** Подпись для подсказки и экранного диктора: «Финансирование · Запись: включено» */
    label: string;
    disabled?: boolean;
    onClick?: () => void;
    /** Текст флажка в колонке «Дополнительно» */
    children?: React.ReactNode;
    size?: number;
}
